var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashedArrowMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 38,
    viewBox: "0 0 8 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 13",
    d: "M4.25 1C4.25 0.861929 4.13807 0.75 4 0.75C3.86193 0.75 3.75 0.861929 3.75 1H4.25ZM3.82322 37.1768C3.92085 37.2744 4.07915 37.2744 4.17678 37.1768L5.76777 35.5858C5.8654 35.4882 5.8654 35.3299 5.76777 35.2322C5.67014 35.1346 5.51184 35.1346 5.41421 35.2322L4 36.6464L2.58579 35.2322C2.48816 35.1346 2.32986 35.1346 2.23223 35.2322C2.1346 35.3299 2.1346 35.4882 2.23223 35.5858L3.82322 37.1768ZM3.75 1V2.8H4.25V1H3.75ZM3.75 6.4V10H4.25L4.25 6.4H3.75ZM3.75 13.6V17.2H4.25V13.6H3.75ZM3.75 20.8V24.4H4.25L4.25 20.8H3.75ZM3.75 28V31.6H4.25V28H3.75ZM3.75 35.2V37H4.25V35.2H3.75ZM4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1H4.5ZM3.64645 37.3536C3.84171 37.5488 4.15829 37.5488 4.35355 37.3536L7.53553 34.1716C7.7308 33.9763 7.7308 33.6597 7.53553 33.4645C7.34027 33.2692 7.02369 33.2692 6.82843 33.4645L4 36.2929L1.17157 33.4645C0.976311 33.2692 0.659728 33.2692 0.464466 33.4645C0.269204 33.6597 0.269204 33.9763 0.464466 34.1716L3.64645 37.3536ZM3.5 1V2.8H4.5V1H3.5ZM3.5 6.4V10H4.5L4.5 6.4H3.5ZM3.5 13.6V17.2H4.5V13.6H3.5ZM3.5 20.8V24.4H4.5L4.5 20.8H3.5ZM3.5 28V31.6H4.5V28H3.5ZM3.5 35.2V37H4.5V35.2H3.5Z",
    fill: "#295BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedArrowMob);
export default __webpack_public_path__ + "static/media/dashedArrowMob.b337c096f3134cf6e59daaf4547b61b2.svg";
export { ForwardRef as ReactComponent };